import { Theme } from '@material-ui/core';
import { spacing } from './spacing';

// Style Overrides
export const PaperThemeOverrides: Theme['overrides'] = {
    MuiPaper: {
        rounded: {
            borderRadius: 10,
            padding: spacing(5),
        },
    },
};

// Default Theme Props
export const PaperThemeProps: Theme['props'] = {
    MuiPaper: {
        elevation: 1,
    },
};
